export enum AuthorizationTemplateType {
	Custom = 'Custom',
}
